<template>
	<Col :span="24">
		<VerticalLayout>
			<MasonryContainer singleColumn>
				<MasonryItem
					data-testid="settings-near-enabled-card"
					headerKey="settings.vrsSettingsForm.nearEnabled"
				>
					<Skeleton :paragraph="{ rows: 1 }" :title="false" :loading="isLoading">
						<LabeledSwitch
							v-model="nearEnabled"
							:rightLabel="$t('settings.vrsSettingsForm.nearEnabled')"
							@change="onNearEnabledChange"
						/>
					</Skeleton>
				</MasonryItem>
				<MasonryItem
					data-testid="settings-near-mountpoints-card"
					headerKey="settings.vrsSettingsForm.rtcmMessagesFiltersNEARHeader"
				>
					<RtcmMessagesFiltersGroup
						:loading="isLoading"
						:status="statusData"
						:settings="settings"
						:fetchSettings="fetchSettings"
						:isVrs="false"
						:onUpdateField="onUpdateField"
					/>
				</MasonryItem>
			</MasonryContainer>
			<RouteLeaveModal
				:visible="modalVisible"
				:confirm="modalOk"
				:cancel="modalCancel"
			/>
		</VerticalLayout>
	</Col>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { Col, Skeleton, message } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import Api from '@/api/Api';
import { toCamelCase } from '@/api/ApiHelpers';

import ApiOps from '@/api/ApiOps';

import { showErrorMessage } from '@/components/common/errorMessage';
import RouteLeaveModal from '@/components/common/RouteLeaveModal.vue';
import { useRouteLeaveModal } from '@/components/common/useRouteLeaveModal';
import LabeledSwitch from '@/components/common/LabeledSwitch.vue';
import VerticalLayout from '@/components/common/VerticalLayout.vue';
import MasonryContainer from '@/components/masonry/MasonryContainer.vue';
import MasonryItem from '@/components/masonry/MasonryItem.vue';
import RtcmMessagesFiltersGroup from '@/components/settings/rtcmFilters/RtcmMessagesFiltersGroup.vue';

import { useProvideInjectFormChangedStatuses } from '@/utils/useProvideInject';

export default {
	components: {
		Col,
		Skeleton,
		VerticalLayout,
		MasonryContainer,
		MasonryItem,
		LabeledSwitch,
		RtcmMessagesFiltersGroup,
		RouteLeaveModal,
	},
	setup() {
		const { t } = useI18n();
		const isLoading = ref(true);
		const settings = ref({});
		const statusData = ref({});
		const nearEnabled = ref(false);
		const {
			formChangedStatuses,
			modalVisible,
			modalOk,
			modalCancel,
		} = useRouteLeaveModal();
		const { provideValue } = useProvideInjectFormChangedStatuses;
		provideValue(formChangedStatuses);

		const fetchSettings = (callback, hideLoading) => {
			if (!hideLoading) {
				isLoading.value = true;
			}
			Api.vrsSettingsGet(responseData => {
				settings.value = toCamelCase(responseData.settings);
				statusData.value = responseData.statusData;
				isLoading.value = false;
				if (callback) {
					callback(responseData);
				}
			});
		};
		onMounted(fetchSettings);

		watch(() => settings.value.nearEnabled, value => {
			nearEnabled.value = Boolean(value);
		});

		const handleSettingsUpdateField = response => {
			if (response.status !== 'ok') {
				showErrorMessage(response.errors);
				fetchSettings();
				return;
			}
			message.success(t('settings.vrsSettingsForm.messages.success'));
			ApiOps.profileGetDetails();
		};
		const onUpdateField = (field, value, handler) => {
			Api.vrsSettingsFieldPost(field, value, handler || handleSettingsUpdateField);
		};
		const onNearEnabledChange = value => {
			onUpdateField('nearEnabled', value);
		};

		return {
			isLoading,
			settings,
			statusData,
			nearEnabled,
			fetchSettings,
			onUpdateField,
			onNearEnabledChange,
			modalVisible,
			modalOk,
			modalCancel,
		};
	},
};
</script>
